import styled from 'styled-components';

import Form from 'components/Form';

export const HeaderContainer = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const FooterContainer = styled.div`
  padding: ${({ theme }) => theme.spacings.abs16}px;
  border-top: solid 1px ${({ theme }) => theme.colors.grey(3)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
